//取得高度最大值
class FilterHeight {
  constructor() {
    this.shObjs = $('.sameHeightObjs');
    this.sh     = $('.sameHeight');
  }
  //取得最大高度
  objHeight(el) {
    el.attr('style', '');
    let maxHeight = el.map((i, e) => {
      const $thisItem = $(e);
      return $thisItem.height();
    }).get();
    el.height(Math.max.apply(this, maxHeight));
  }
}




//整合
class SameHeight extends FilterHeight {
  resultHeight(){
    super.objHeight(this.shObjs);
    super.objHeight(this.sh);
    //RWD 調整高度
    $(window).on('resize', () => {
      super.objHeight(this.shObjs);
      super.objHeight(this.sh);
    });
  }
}




//輸出
export {SameHeight};


// WEBPACK FOOTER //
// ./js_new/same_height.js